import _implicitStylesheets from "./zoomButtons.css";

import _implicitScopedStylesheets from "./zoomButtons.scoped.css?scoped=true";

import _lightningButtonIcon from "lightning/buttonIcon";
import _lightningButton from "lightning/button";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    classMap: {
      "zoomButtons": true
    },
    key: 0
  }, [$cmp.iconButtons ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    props: {
      "variant": "border-filled",
      "alternativeText": "Zoom Out",
      "title": "Zoom Out",
      "iconName": "utility:zoomout"
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.zoomOut))
    }
  }, []) : null, $cmp.iconButtons ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    props: {
      "variant": "border-filled",
      "alternativeText": "Zoom In",
      "title": "Zoom In",
      "iconName": "utility:zoomin"
    },
    key: 2,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.zoomIn))
    }
  }, []) : null, !$cmp.iconButtons ? api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "Zoom Out",
      "iconName": "utility:zoomout"
    },
    key: 3,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.zoomOut))
    }
  }, []) : null, !$cmp.iconButtons ? api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "Zoom In",
      "iconName": "utility:zoomin"
    },
    key: 4,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.zoomIn))
    }
  }, []) : null])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-zoomButtons_zoomButtons"
